<template>
  <el-table
    :data="countTable"
    border
    :span-method="objectSpanMethod"
    style="width: 100%"
    :maxHeight="maxHeight"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column prop="memberGradeName" label="会员等级" align="center" />
    <el-table-column prop="frequencyInterval" label="购买频次" align="center" min-width="110"/>
    <el-table-column prop="payCount" label="付款人数" align="center" />
    <el-table-column
      prop="payCountRatioStr"
      label="付款人数占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="tradeAmount" label="付款金额" align="center" />
    <el-table-column
      prop="tradeAmountRatioStr"
      label="付款金额占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="payTimes" label="付款单量" align="center" />
    <el-table-column
      prop="payTimesRatioStr"
      label="付款单量占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="payNum" label="付款件数" align="center" />
    <el-table-column
      prop="payNumRatioStr"
      label="付款件数占比"
      align="center"
			min-width="110"
    />
    <el-table-column prop="payAvgAmount" label="客单价" align="center" />
    <el-table-column prop="timesAvgAmount" label="笔单价" align="center" />
    <el-table-column prop="numAvgAmount" label="件单价" align="center" />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";
export default {
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    countTable() {
      return this.tableData;
    },
  },
  methods: {
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const current = this.countTable[rowIndex].memberGrade;
        const prev = this.countTable[rowIndex - 1]?.memberGrade;
        // 如果和上一行相同
        // 当前单元格隐藏
        if (current === prev) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        // 计算需要合并多少行
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.countTable.length; i++) {
          if (this.countTable[i].memberGrade === current) {
            rowspan++;
          } else {
            break;
          }
        }
        return {
          rowspan,
          colspan: 1,
        };
      }
    },
  },
};
</script>
